export enum CustomerStatus {
  // The customer's balance is in arrears.
  InArrears = 'In arrears',
  // The customer has a full payment plan in place.
  FullPlanInPlace = 'Full plan in place',
  // The customer has a temporary plan in place.
  TemporaryPlanInPlace = 'Temporary plan in place',
  // The customer has no payment plan in place.
  NoPlanInPlace = 'No plan in place',
  // The customer's account has been already closed.
  AccountClosed = 'Account closed',
  // The customer's is in the legal process.
  LegalProcess = 'Legal process',
  // The customer's account is in the process of closing.
  ClosingInProgress = 'Closing In Progress',
}
